export default __webpack_public_path__ + "static/media/crip-com.1efad943.png";